// extracted by mini-css-extract-plugin
export default {"root":"TopOperations_root__gdjVB","search":"TopOperations_search__FdWsq","option":"TopOperations_option__4VcoO","btn":"TopOperations_btn__IgPcQ"};